import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'components/common_v2/layouts';
import { Message } from './message';

export const MessageList = ({
  messages,
  handleMessageClick,
}) => (
  <Box flexDirection="column" data-test-id="notifications__message-list">
    {messages.map((message) => (
      <Message handleMessageClick={handleMessageClick} message={message} notify indicatorPosition={{ right: '5px', bottom: '10px' }} />
    ))}
  </Box>
);

MessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleMessageClick: PropTypes.func.isRequired
};
